export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) { window.location.assign(`/#${encodeURIComponent(id)}`); return; }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70 });
  } else {
    el.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
  }
};
